/* unplugin-vue-components disabled */import { render } from "./source-popover.vue?vue&type=template&id=9a6dd98c&scoped=true"
import script from "./source-popover.vue?vue&type=script&lang=js"
export * from "./source-popover.vue?vue&type=script&lang=js"

import "./source-popover.vue?vue&type=style&index=0&id=9a6dd98c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a6dd98c"],['__file',"src/components/sources/source-popover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a6dd98c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a6dd98c', __exports__)) {
    api.reload('9a6dd98c', __exports__)
  }
  
  module.hot.accept("./source-popover.vue?vue&type=template&id=9a6dd98c&scoped=true", () => {
    api.rerender('9a6dd98c', render)
  })

}


export default __exports__